import React from 'react';
import { daMinutiAOre } from './turniHelper';
import { Button } from "react-bootstrap";
import { downloadCsv } from '../utilities/NetUtilities';

function TabellaSede({ tabellaSede, minutiTotSede, urlCsv }) {

    const printRighe = (tabellaServizi, sede, indexSede, rowClass) => {
        const nServizi = Object.keys(tabellaServizi).length;
        return (
            Object.keys(tabellaServizi).map((servizio, indexServizio) => {
                var minuti = tabellaServizi[servizio]
                return <tr
                    className={`cellaSpaziosa ${rowClass}`}
                    id={indexSede - indexServizio}
                    key={indexSede + '-' + indexServizio}>
                    {indexServizio === 0 && <td
                        rowSpan={nServizi + 1}
                        id={'zona-sede-' + indexSede + '-' + indexServizio}
                        className="inEvidenza cellaSpaziosa bordiSpessi">{sede}</td>}
                    <td
                        className='cellaSpaziosa bordiSpessi'
                        id={'zona-servizio-' + indexSede + '-' + indexServizio}>{servizio}</td>
                    <td
                        className="center cellaSpaziosa bordiSpessi"
                        id={'zona-ore-' + indexSede + '-' + indexServizio}>{daMinutiAOre(minuti)}</td>
                </tr>
            })
        )
    }

    const printTotaleSede = (sede, indexSede, rowClass) => {
        return (<tr key={'totale-' + indexSede}>
            <td className={`inEvidenza right cellaSpaziosa bordiSpessi ${rowClass}`}>totale ore</td>
            <td className={`inEvidenza center cellaSpaziosa bordiSpessi ${rowClass}`}
                id={'zona-totore-' + indexSede}>{daMinutiAOre(minutiTotSede[sede])}</td></tr>
        )
    }

    const printTabella = () => {
        return (
            Object.keys(tabellaSede).map((sede, indexSede) => {
                const rowClass = indexSede % 2 === 0 ? 'lineaGrigia' : 'lineaBianca';
                var tabellaServizi = tabellaSede[sede];
                if (Object.keys(tabellaServizi).length === 0) {
                    return (
                        <tr key={`table-${indexSede}`} className={`cellaSpaziosa ${rowClass}`}>
                            <td className="inEvidenza cellaSpaziosa bordiSpessi" id={'zona-sede-' + indexSede + '-0'}>{sede}</td>
                            <td className="inEvidenza right cellaSpaziosa bordiSpessi">totale ore</td>
                            <td className="inEvidenza center cellaSpaziosa bordiSpessi" id={'zona-totore-' + indexSede}>{daMinutiAOre(minutiTotSede[sede])}</td>
                        </tr>
                    );
                }
                return (
                    <React.Fragment key={`table-${indexSede}`}>
                        {printRighe(tabellaServizi, sede, indexSede, rowClass)}
                        {printTotaleSede(sede, indexSede, rowClass)}
                    </React.Fragment>
                );
            })
        );
    }

    return (
        <div id="tabella-sede" className='table-responsive'>
            <h2 className='inEvidenza'>Totale zona
                <Button
                    data-toggle="tooltip"
                    title="Download CSV"
                    className='btnGenerale'
                    variant="flat"
                    size="sm"
                    id="csv-zona"
                    onClick={() => { downloadCsv(urlCsv, "totale-zona.csv") }}
                >scarica</Button></h2>
            {tabellaSede && <table id="tabella-sede" className="table-bordered bottom-space ">
                <thead className="App">
                    <tr key="intestazione">
                        <th className="inEvidenza cellaSpaziosa bordiSpessi">sede</th>
                        <th className="inEvidenza cellaSpaziosa bordiSpessi">servizio</th>
                        <th className="inEvidenza cellaSpaziosa bordiSpessi">totale (hh:mm)</th>
                    </tr>
                </thead>
                <tbody>
                    {printTabella()}
                </tbody>
            </table>}
        </div>
    )
}

export default TabellaSede;